<script lang="ts">
    import { page } from "$app/stores"
    import Icon from "@components/material/Icon.svelte"
    import { navigatorOpen, openToNotation } from "@components/navigator/Navigator.svelte"

    function openCurrentPageInContents() {
        const notation = $page.params.notation
        if (notation) openToNotation(notation, { exact: false })
    }
</script>

<button
    type="button"
    class="mobile-contents-tab"
    class:open={$navigatorOpen}
    aria-controls="navigator"
    aria-expanded={$navigatorOpen}
    aria-label="Open current page in table of contents"
    on:click={openCurrentPageInContents}
>
    <Icon icon="book" />
</button>

<style>
    .mobile-contents-tab {
        display: none;
    }

    :global(.reader-layout-compact) .mobile-contents-tab {
        appearance: none;
        position: sticky;
        top: calc(var(--safe-area-inset-top, 0rem) + 0.5rem);
        z-index: 4;
        display: grid;
        place-items: center;
        width: 3rem;
        height: 2.75rem;
        margin: 0 0 calc(-2.75rem - 0.5rem);
        padding: 0;
        border: 1px solid var(--color-purple-100);
        border-left: 0;
        border-radius: 0 999px 999px 0;
        box-shadow: none;
        background: var(--color-purple-50);
        color: var(--color-purple-700);
        cursor: pointer;
        transition:
            background-color 0.16s ease,
            color 0.16s ease,
            transform 0.16s ease;
    }

    :global(.reader-layout-compact) .mobile-contents-tab:hover,
    :global(.reader-layout-compact) .mobile-contents-tab.open {
        background: var(--color-purple-100);
    }

    :global(.reader-layout-compact) .mobile-contents-tab:active {
        transform: translateY(1px);
    }

    :global(.reader-layout-compact) .mobile-contents-tab :global(svg) {
        width: 1.35rem;
        height: 1.35rem;
    }

    :global(.darkmode) .mobile-contents-tab {
        border-color: var(--color-grey-700);
        background: var(--color-grey-800);
        color: var(--color-purple-100);
    }

    :global(.darkmode) .mobile-contents-tab:hover,
    :global(.darkmode) .mobile-contents-tab.open {
        background: var(--color-grey-700);
    }
</style>
